export default {
  academicPeriodConfig: {
    id: '',
    applyPeriod: '',
    applyPeriodCode: '',
    learnPeriod: '',
    learnPeriodCode: '',
    enrollPeriod: '',
    enrollPeriodCode: '',
  },
  academicPeriodConfigs: [],
  processing: false,
  error: null,
}



